<nav class="account-tabs" aria-label="Account sections">
  <a
    class="account-tabs__tab"
    routerLink="/my-account"
    routerLinkActive="account-tabs__tab--active"
    [routerLinkActiveOptions]="{exact: true}"
  >
    {{ 'marketplace.account.tabs.bookings' | transloco }}
  </a>
  <a
    class="account-tabs__tab"
    routerLink="/my-discounts"
    routerLinkActive="account-tabs__tab--active"
  >
    {{ 'marketplace.account.tabs.gift-cards' | transloco }}
  </a>
</nav>
